import axios from "axios";

export default function Telemetry(props) {
  let message = props.message;
  let originator = props.originator;

  if (!message instanceof String) {
      message = JSON.stringify(message);
  }

  let params = new URLSearchParams();
  params.append("originator", originator);
  params.append("message", message);
  let url = "/api/error?" + params.toString();
  axios.get(url)
      .then(response => {
          console.log(response);
      })
      .catch(error => {
          console.log(error);
      });
    return null;
}